import React, { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { CSSTransition } from 'react-css-transition'
import { Auth, API } from 'aws-amplify'
import uuidv4 from 'uuid/v4'
import { createBooking } from '../actions/bookingActions'
import LoginForm from './LoginForm'
import Modal from '../components/Modal'
import TransitionStyles from '../lib/transitionStyles'
import Spinner from '../components/Spinner'
import InvitationBlock from '../components/bookingHome/InvitationBlock'
import Header from "../components/bookingHome/Header"
import SignedInBlock from '../components/bookingHome/SignedInBlock'
import SignedOutBlock from '../components/bookingHome/SignedOutBlock'
import PeopleAmountBlock from '../components/bookingHome/PeopleAmountBlock'
import InvitationActionBlock from '../components/bookingHome/InvitationActionBlock'
import { atUserBookingsCapacity, fetchParticipants, calculateHoursCount, fetchUserInfo } from '../lib/booking'
import { objEmpty } from '../lib/utils'
import ErrorBookingsCapacity from '../components/ErrorBookingsCapacity';

class BookingHomePage extends Component {
  
  constructor(props) {
    super(props)
    this.state = {
      isLoading: true,
      user: null,
      // Two extra properties were added to "booking" object as initial values for "amountPeople" & "amountPeopleKids"
      booking: {...props.booking, 
                ...(!props.booking.amountPeople) && {amountPeople: 1},
                ...(!props.booking.amountPeopleKids) && {amountPeopleKids: 0}},
      showValidationError: false,
      currentModal: null,
      atUserBookingsCapacity: false
    }
    this.updateBooking  = this.updateBooking.bind(this)
    this.acceptInvitation  = this.acceptInvitation.bind(this)
    this.onChange = this.onChange.bind(this)
    this.keyCount = 0
    this.getKey = this.getKey.bind(this)
    this.openLoginModal = this.openLoginModal.bind(this)
    this.handleLogout = this.handleLogout.bind(this)
    this.gotoDashboard = this.gotoDashboard.bind(this)
    this.isValid = this.isValid.bind(this)
  }
  
  async componentDidMount() {
    // const { state } = this
    this.setUserState()
    this.fetchInvitation()
    this.resetBookingIfCompleted()
    this.setCapacityState()
    // if (state.booking.loggedInAtBeginning) {
      this.setParticipantsState()
    // }
  }
  
  onChange(name, value) {
    const { booking } = this.state
    this.setState({
      booking: {
        ...booking,
        [name]: value
      } 
    })
  }
  
  getKey() {
    this.keyCount += 1
    return this.keyCount
  } 

  async setUserState() {
    this.setState({ isLoading: true })
    try {
      const user = await Auth.currentAuthenticatedUser()
      this.setState({ user })
    } catch (e) { /* Do nothing */ }
    this.setState({ isLoading: false })
    return Promise.resolve()
  }

  async setCapacityState() {
    this.setState({ atUserBookingsCapacity: (await atUserBookingsCapacity()) });
  }
  
  async setParticipantsState() {
    try {
      const participants = await fetchParticipants()
      this.setState({ participants });
    } catch (error) { /* Do nothing */ }
  }

  async fetchInvitation() {
    const { props } = this
    const { invitationId } = props.match.params
    if (!invitationId) {
      return
    }

    try {
      const invitation = await API.get('cphill', `/invitations/${invitationId}`)
      this.setState({ invitation })
    } catch (e) {
      console.debug(e)
    }
  }

  async updateBooking() {
    const {props, state} = this
    const {booking, user, invitation, participants} = state

    if (!state.atUserBookingsCapacity) {
      if (!booking.key) {
        booking.key = uuidv4()
      }
      booking.people = booking.bookerNotAttending
        ? []
        : [{ isBooker: true }]
      
      if (!objEmpty(invitation)) {
        booking.invitation = invitation
        booking.amountPeople = 1
        booking.hoursCount = calculateHoursCount(invitation.booking.dateStart, invitation.booking.dateEnd)
        booking.whenStartTime = invitation.booking.dateStart
        booking.whenEndTime = invitation.booking.dateEnd
      }

      booking.loggedInAtBeginning = !!user
      this.setState({ isLoading: true })
      const userInfo = booking.loggedInAtBeginning
        ? await fetchUserInfo(user)
        : {};
      this.setState({ isLoading: false })
      const membership = userInfo && userInfo.memberships && userInfo.memberships.find(m => m.isBookersOwn && !m.status)
      const passType = (membership && membership.type) || "passHourlyAdult"

      //
      const adultParticipants = [...Array(booking.amountPeople)].map(() => ({ageCategory: "adult", passType:"passHourlyAdult"}))

      if (!booking.bookerNotAttending) {
        adultParticipants[0] = {
          expanded: (booking.amountPeople === '1'),
          userId: userInfo.id,
          firstName: userInfo.firstName || (invitation && invitation.firstName),
          lastName: userInfo.lastName || (invitation && invitation.lastName),
          isBooker: true,
          membership,
          ageCategory: "adult",
          passType
        }
      }
      
      const kidsParticipants = [...Array(booking.amountPeopleKids)].map(() => ({ ageCategory: "child", passType:"passHourlyChild" }))

      booking.people = [...adultParticipants, ...kidsParticipants]

      props.createBooking(booking)

      if (booking.invitation) {
        props.history.push('/bookings/people-details')
      } else {
        props.history.push(participants && participants.length > 0 ? '/bookings/participants' : '/bookings/when')
      }
    } else {
      this.setState({ showValidationError: true })
    }
  }

  isValid() {
    const { booking } = this.state
    return booking.amountPeople > 0 // && booking.acceptTerms
  }

  acceptInvitation() {
    const { props, state } = this
    const { booking } = state
    booking.amountPeople = 1 // to make booking valid
    props.createBooking(booking)
    this.updateBooking()
  }

  openLoginModal() {
    const closeAction = () => { this.setState({ currentModal: null }) }

    const afterLoginAction = async () => {
      this.setUserState()
      this.setCapacityState()
      this.setParticipantsState()
      closeAction()
    }

    this.setState({
      currentModal: (
        <Modal closeAction={closeAction}>
          <LoginForm afterLoginAction={afterLoginAction} />
        </Modal>
      )
    })    
  }

  async handleLogout(event) {
    const { props } = this
    event.preventDefault()
    await Auth.signOut()
    this.setState({ user: null, participants: null })
    props.createBooking({})
    this.setCapacityState()
  }
  
  gotoDashboard() {
    const {props} = this
    props.history.push('/dashboard')
  }

  resetBookingIfCompleted() {
    const { props, state } = this

    if (state.booking && state.booking.completed) {
      console.debug("Reset")
      props.createBooking({}) // Reset if booking in local storage is complete
      this.setState({ booking: {amountPeople: 1, amountPeopleKids: 0} })
    }
  }  

  render() {
    const { state } = this
    // const { acceptTerms } = state.booking

    // Strange fix - throws an error in console without this (https://github.com/wikiwi/react-css-transition/issues/5)
    CSSTransition.childContextTypes = {}
    
    if (state.isLoading) {
      return (
        <Spinner />
      )
    }

    return (
      <>
        {state.currentModal}

        <div className="container mx-auto px-2 md:px-0">
          <div className="lg:w-2/3 xl:w-3/5 mt-10 mb-12 mx-auto">
            {!objEmpty(state.invitation) && (
              <CSSTransition {...TransitionStyles} transitionAppear active>
                <InvitationBlock invitation={state.invitation} />
              </CSSTransition>
            )}

            <Header getKey={this.getKey} />

            {state.user ? (
              <SignedInBlock handleLogout={this.handleLogout} gotoDashboard={this.gotoDashboard} />
            ) : (
              <SignedOutBlock openLoginModal={this.openLoginModal} />
            )}

            {!objEmpty(state.invitation)
              ? (
                <InvitationActionBlock
                  getKey={this.getKey}
                  acceptInvitation={this.acceptInvitation}
                />
              ) : (
                <>
                  <PeopleAmountBlock 
                    user={state.user}
                    booking={state.booking}
                    updateBooking={this.updateBooking}
                    onChange={this.onChange}
                    // acceptTerms={acceptTerms}
                    showValidationError={state.showValidationError}
                    isValid={this.isValid}
                    getKey={this.getKey}
                    atUserBookingsCapacity={state.atUserBookingsCapacity}
                  />
                  { state.atUserBookingsCapacity && (
                    <ErrorBookingsCapacity wrapperClassName="mt-4" />
                  )}
                  <div className="border-b mt-8" />
                </>
              )}
          </div>
        </div>
      </>
    )
  }
}

BookingHomePage.propTypes = {
  booking: PropTypes.shape({ booking: PropTypes.object })
}

BookingHomePage.defaultProps = {
  booking: {}
}

const mapStateToProps = state => ({
  booking: state.booking
})

export default connect(mapStateToProps, { createBooking })(BookingHomePage)